import axios from "../axiosInstance";
import { ResetModuleRequest, ResetModuleResponse } from "./types";

export const resetModule = async (
  requestData: ResetModuleRequest,
): Promise<ResetModuleResponse> => {
  const response = await axios.post<ResetModuleResponse>(
    `/api/learning-center/modules/${requestData.moduleId}/reset`,
  );

  return response.data;
};
